<template>
  <span v-if="story">
    <span>{{ text }}</span>
  </span>
</template>
<script>
export default {
  props: {
    story: Object
  },
  name: 'story',
  computed: {
    isText () {
      return this.story.type === 'text'
    },
    isUrl () {
      return this.story.type === 'url'
    },
    text () {
      return this.story.text
    }
  }
}
</script>
